'use client';

import Layout from '../../components/Layout';
import SubDocsLayout from '../../components/SubDocsLayout';
import useTranslation from '../../lib/translation';
import SEOHead from '../../components/SEOHead';

const Domains = () => {
  const { t, lang } = useTranslation('common');

  return (
    <Layout>
      <SEOHead
        title={lang === 'lt' ? Array.isArray(t('domains.pageTitle')) ? (t('domains.pageTitle') as string[]).join(' ') : (t('domains.pageTitle') as string) : 'Domains | LB Websites'}
        description={
          lang === 'lt'
            ? Array.isArray(t('domains.description')) ? (t('domains.description') as string[]).join(' ') : (t('domains.description') as string)
            : 'Learn how LB Websites handles domain registration and transfers for your online business.'
        }
        keywords='domain registration, domain management, domain services, website domains, domain setup'
        canonicalUrl={lang === 'lt' ? '/lt/sub/domenai' : '/sub/domains'}
        lang={lang}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name:
            lang === 'lt' ? Array.isArray(t('domains.pageTitle')) ? (t('domains.pageTitle') as string[]).join(' ') : (t('domains.pageTitle') as string) : 'Domains | LB Websites',
          description:
            lang === 'lt'
              ? Array.isArray(t('domains.description')) ? (t('domains.description') as string[]).join(' ') : (t('domains.description') as string)
              : 'Learn how LB Websites handles domain registration and transfers for your online business.',
          url: `https://www.lbvisible.com${
            lang === 'lt' ? '/lt/sub/domenai' : '/sub/domains'
          }`,
          inLanguage: lang === 'lt' ? 'lt' : 'en',
          provider: {
            '@type': 'Organization',
            name: 'LB Visible',
          },
        }}
      />

      <SubDocsLayout>
        <h1 className='text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-white mb-4 text-left'>
          {lang === 'lt' ? t('domains.heading') : 'Domains'}
        </h1>
        <p className='text-base text-gray-600 dark:text-gray-300 mb-10 text-left leading-relaxed'>
            {lang === 'lt'
              ? t('domains.subtitle')
              : 'Your domain name is your digital address. We make it easy to register or migrate your domain as part of your website launch.'}
          </p>

          <ol className='space-y-8'>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-white/5 border border-gray-200/50 dark:border-white/10'>
                1
              </span>
              <div>
                <h2 className='font-semibold text-gray-900 dark:text-white mb-1.5'>
                  {lang === 'lt' ? t('domains.services.registration.title') : 'Register a new domain'}
                </h2>
                <p className='text-sm text-gray-600 dark:text-gray-400 leading-relaxed'>
                  {lang === 'lt'
                    ? t('domains.services.registration.desc')
                    : "Choose your brand name and we'll help you secure it through trusted registrars like GoDaddy, Namecheap, or Google Domains."}
                </p>
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-white/5 border border-gray-200/50 dark:border-white/10'>
                2
              </span>
              <div>
                <h2 className='font-semibold text-gray-900 dark:text-white mb-1.5'>
                  {lang === 'lt' ? t('domains.services.management.title') : 'Already own a domain?'}
                </h2>
                <p className='text-sm text-gray-600 dark:text-gray-400 leading-relaxed'>
                  {lang === 'lt'
                    ? t('domains.services.management.desc')
                    : "We'll connect it to your new website and handle DNS setup professionally."}
                </p>
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-white/5 border border-gray-200/50 dark:border-white/10'>
                3
              </span>
              <div>
                <h2 className='font-semibold text-gray-900 dark:text-white mb-1.5'>
                  {lang === 'lt' ? t('domains.services.transfer.title') : 'Need to transfer your domain?'}
                </h2>
                <p className='text-sm text-gray-600 dark:text-gray-400 leading-relaxed'>
                  {lang === 'lt'
                    ? t('domains.services.transfer.desc')
                    : 'We guide you through the transfer process, including unlocks and authorization codes, to ensure a smooth handover.'}
                </p>
              </div>
            </li>
          </ol>
      </SubDocsLayout>
    </Layout>
  );
};

export default Domains;
